module.exports = __webpack_public_path__ + "static/media/16UNODC22.288b8ae2.jpg";